import React, { useState, useEffect, useCallback } from 'react';
import { Box, IconButton } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const AUTOPLAY_MS = 2000;
const FADE_MS = 220;

const banners = [
  { src: '/herosection/1500 Web Banne.jpg.jpeg', id: '1500-offer' },
  { src: '/herosection/1200 Web Banner.jpg.jpeg', id: '1200-offer' },
  { src: '/herosection/Botox Web Banner.jpg.jpeg', id: 'botox' },
  { src: '/herosection/Bridal.jpg.jpeg', id: 'bridal' },
  { src: '/herosection/Glowing Peels.jpg.jpeg', id: 'peels' },
  { src: '/herosection/Hydra Facial  Web Banner.jpg.jpeg', id: 'hydra' },
];

export default function MainHeroSlider() {
  const [index, setIndex] = useState(0);
  const [loadedBanners, setLoadedBanners] = useState(() => ({
    [banners[0].src]: true,
  }));

  const handleNext = useCallback(() => {
    setIndex((prev) => (prev + 1) % banners.length);
  }, []);

  const handlePrev = useCallback(() => {
    setIndex((prev) => (prev - 1 + banners.length) % banners.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      handleNext();
    }, AUTOPLAY_MS);
    return () => clearInterval(timer);
  }, [handleNext]);

  useEffect(() => {
    let isMounted = true;

    banners.forEach(({ src }) => {
      const img = new Image();
      img.loading = 'eager';
      img.decoding = 'async';
      img.fetchPriority = 'high';
      img.src = src;
      img.onload = () => {
        if (!isMounted) return;
        setLoadedBanners((prev) => (prev[src] ? prev : { ...prev, [src]: true }));
      };
      img.onerror = () => {
        if (!isMounted) return;
        setLoadedBanners((prev) => (prev[src] ? prev : { ...prev, [src]: true }));
      };
    });

    return () => {
      isMounted = false;
    };
  }, []);

  const currentSrc = banners[index].src;
  const visibleIndex = loadedBanners[currentSrc]
    ? index
    : (index - 1 + banners.length) % banners.length;

  return (
    <Box sx={{ position: 'absolute', inset: 0, overflow: 'hidden', zIndex: 0 }}>
      {banners.map((banner, i) => (
        <Box
          key={banner.id}
          sx={{
            position: 'absolute',
            inset: 0,
            opacity: i === visibleIndex ? 1 : 0,
            transition: `opacity ${FADE_MS}ms ease`,
            zIndex: i === visibleIndex ? 1 : 0,
            willChange: 'opacity',
          }}
        >
          <Box
            component="img"
            src={banner.src}
            alt=""
            loading="eager"
            decoding="async"
            fetchPriority={i === index ? 'high' : 'auto'}
            onLoad={() => {
              setLoadedBanners((prev) => (prev[banner.src] ? prev : { ...prev, [banner.src]: true }));
            }}
            sx={{
              position: 'absolute',
              inset: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />

          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              background: 'linear-gradient(to top, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.2) 50%, rgba(0,0,0,0.4) 100%)',
            }}
          />
        </Box>
      ))}
      
      {/* Navigation Arrows */}
      <IconButton
        onClick={handlePrev}
        sx={{
          position: 'absolute',
          left: { xs: 8, md: 20 },
          top: '50%',
          transform: 'translateY(-50%)',
          zIndex: 10,
          backgroundColor: 'rgba(255,255,255,0.2)',
          color: '#fff',
          padding: { xs: '4px', md: '8px' },
          '&:hover': {
            backgroundColor: '#FF0099',
            color: '#fff',
          },
          '& .MuiSvgIcon-root': {
            fontSize: { xs: '1.2rem', md: '1.5rem' }
          },
          transition: 'all 0.3s ease',
        }}
      >
        <ArrowBackIosNewIcon />
      </IconButton>

      <IconButton
        onClick={handleNext}
        sx={{
          position: 'absolute',
          right: { xs: 8, md: 20 },
          top: '50%',
          transform: 'translateY(-50%)',
          zIndex: 10,
          backgroundColor: 'rgba(255,255,255,0.2)',
          color: '#fff',
          padding: { xs: '4px', md: '8px' },
          '&:hover': {
            backgroundColor: '#FF0099',
            color: '#fff',
          },
          '& .MuiSvgIcon-root': {
            fontSize: { xs: '1.2rem', md: '1.5rem' }
          },
          transition: 'all 0.3s ease',
        }}
      >
        <ArrowForwardIosIcon />
      </IconButton>

      {/* Navigation Dots */}
      <Box
        sx={{
          position: 'absolute',
          bottom: { xs: 15, md: 30 },
          left: '50%',
          transform: 'translateX(-50%)',
          display: 'flex',
          gap: { xs: 1, md: 1.5 },
          zIndex: 10,
          backgroundColor: 'rgba(0,0,0,0.2)',
          px: { xs: 1.5, md: 2 },
          py: { xs: 0.5, md: 1 },
          borderRadius: 5,
          backdropFilter: 'blur(4px)',
        }}
      >
        {banners.map((_, i) => (
          <Box
            key={i}
            onClick={() => setIndex(i)}
            sx={{
              width: i === index ? { xs: 20, md: 30 } : { xs: 6, md: 10 },
              height: { xs: 6, md: 10 },
              borderRadius: 5,
              backgroundColor: i === index ? '#FF0099' : 'rgba(255,255,255,0.5)',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
          />
        ))}
      </Box>
    </Box>
  );
}
